module.exports = __webpack_public_path__ + "img/accountBg.b91e83ac.jpg";